<template>
    <section class="">
        <div class="relative grid items-center">
            <nuxt-img :width="backgroundImageWidth" :height="backgroundImageHeight" format="webp" :src="backgroundImageSrc"
                alt="background section image" class="absolute object-cover w-full h-full" loading="lazy"
                sizes="xs:360px sm:640px md:768px lg:1024px xl:1600px" />
            <div class="relative z-10 py-10 md:py-20">
                <div class="grid items-center max-w-screen-xl grid-cols-12 px-4 mx-auto gap-x-6 lg:gap-x-12 gap-y-8">
                    <div class="col-span-12 md:col-span-6 sm-max:order-2">
                        <nuxt-img :width="sectionImageWidth" :height="sectionImageHeight" format="webp" :src="sectionImageSrc"
                            alt="section image" class="mx-auto lg:w-full" loading="lazy"
                            sizes="xs:360px sm:640px md:768px lg:1024px xl:579px" />
                    </div>

                    <div class="max-w-sm col-span-12 mx-auto space-y-4 md:col-span-6">
                        <h4 class="font-bold text-center text-white h2" v-html="titleText"></h4>
                        <p class="font-normal text-center text-white textp font-ww-regular lg:px-6" v-html="descriptionText"></p>
                        <div class="pt-8 md:pt-16">
                            <nuxt-img :width="logoWidth" :height="logoHeight" format="webp" :src="logoSrc"
                                alt="section image" class="m-auto lg:full lg:w-42 w-36" loading="lazy"
                                sizes="xs:200px sm:200px md:200px lg:200px xl:200px" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

const props = defineProps({
    backgroundImageSrc: {
        type: String,
        default: '/assets/images/rainforest.jpg'
    },
    backgroundImageWidth: {
        type: Number,
        default: 1600
    },
    backgroundImageHeight: {
        type: Number,
        default: 854
    },
    sectionImageSrc: {
        type: String,
        default: '/assets/images/rainforest-2.jpg'
    },
    sectionImageWidth: {
        type: Number,
        default: 579
    },
    sectionImageHeight: {
        type: Number,
        default: 647
    },
    logoSrc: {
        type: String,
        default: '/assets/images/rainfores-logo.png'
    },
    logoWidth: {
        type: Number,
        default: 240
    },
    logoHeight: {
        type: Number,
        default: 170
    },
    titleText: {
        type: String,
        default: '“Drink Coffee And Save The Planet”'
    },
    descriptionText: {
        type: String,
        default: 'A portion of the profits are donated to Rainforest Trust and Project Alianza for conservation of the wildlife and to build schools in local areas for the farmers children.'
    }
});

defineBuilderComponent({
    friendlyName: 'Background Text Image Logo',
    inputs: [
        {
            name: 'backgroundImageSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png'],
            defaultValue: '/assets/images/rainforest.jpg'
        },
        {
            name: 'backgroundImageWidth',
            type: 'number',
            defaultValue: 1600
        },
        {
            name: 'backgroundImageHeight',
            type: 'number',
            defaultValue: 854
        },
        {
            name: 'sectionImageSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png'],
            defaultValue: '/assets/images/rainforest-2.jpg'
        },
        {
            name: 'sectionImageWidth',
            type: 'number',
            defaultValue: 579
        },
        {
            name: 'sectionImageHeight',
            type: 'number',
            defaultValue: 647
        },
        {
            name: 'logoSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png'],
            defaultValue: '/assets/images/rainfores-logo.png'
        },
        {
            name: 'logoWidth',
            type: 'number',
            defaultValue: 240
        },
        {
            name: 'logoHeight',
            type: 'number',
            defaultValue: 170
        },
        {
            name: 'titleText',
            type: 'richText',
            defaultValue: '“Drink Coffee And Save The Planet”'
        },
        {
            name: 'descriptionText',
            type: 'richText',
            defaultValue: 'A portion of the profits are donated to Rainforest Trust and Project Alianza for conservation of the wildlife and to build schools in local areas for the farmers children.'
        }
    ]
});
</script>
